import { render, staticRenderFns } from "./ProcessingTimeNew.vue?vue&type=template&id=745366c1&"
import script from "./ProcessingTimeNew.vue?vue&type=script&lang=js&"
export * from "./ProcessingTimeNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports